import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import { TypeChecker } from '@attain-apps/type-guards'

import * as state from '../../../../../../../../../state'
import * as shared from '../shared'

import * as filters from './filters'

/** Identifies this report to the configuration plugin. */
const REPORT_ID = ents.extra.space.Report.Id.UnassignedSponsoredPeople

/**
 * Body of the Unassigned Sponsored People report: the people themselves, with
 * the report's configuration below them.
 */
@ngCore.Component({
  imports: [
    ds.input.checkbox.Component,
    ds.layout.widget.Component,
    ds.table.Component,
    filters.Component,
    shared.commentModal.Component,
  ],
  selector: 'atn-space-report-unassigned-sponsored-people',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.space.full.unassignedSponsoredPeople.Collection} */
  public readonly unassignedSponsoredPeopleEc = ngCore.inject(
    state.space.full.unassignedSponsoredPeople.Collection,
  )

  /** @see {@link state.space.reports.Collection} */
  private readonly _reportsEc = ngCore.inject(state.space.reports.Collection)

  /** @see {@link state.space.reports.plugins.configuration.Plugin} */
  public readonly configurationPlugin = this._reportsEc.plugins
    .lookup(state.space.reports.plugins.configuration.Plugin)
    .get()

  /** Configuration settings for this report. */
  public readonly configurationSg =
    this.configurationPlugin.selectors.getSettings(REPORT_ID).asSignal

  /** @see {@link state.space.reports.plugins.configuration.Plugin.selectors.isStandardUser} */
  public readonly isStandardUserSg =
    this.configurationPlugin.selectors.isStandardUser.asSignal

  /** Canonical table input for the unassigned sponsored people. */
  public readonly unassignedSponsoredPeopleTableConfig: ds.table.ec.Config.Input<state.space.full.unassignedSponsoredPeople.TypeParams> =
    {
      collection: this.unassignedSponsoredPeopleEc,
      view: {
        pagination: true,
        title: 'Unassigned Sponsored People',
      },
    }

  /** Whether an organization filter is currently narrowing the list. */
  public readonly hasAppliedFiltersSg = ngCore.computed(
    (
      appliedFilters = this.unassignedSponsoredPeopleEc.plugins.currentListPlugin.appliedParams.selectors.filters.asSignal(),
    ) => Object.values(appliedFilters ?? {}).some(TypeChecker.isNotNullish.raw),
  )

  /** Starts editing the Current List parameters. */
  public filtersClickHandler(): void {
    this.unassignedSponsoredPeopleEc.plugins.currentListPlugin.feature.actions.startEditingParams
      .from('Space.UnassignedSponsoredPeople.Filters.Icon.Clicked')
      .dispatch()
  }

  /** Handles a change to the "Show Salary Information" checkbox. */
  public showSalaryInformationChangeHandler(value: boolean): void {
    this.configurationPlugin.actions.edit
      .from(
        'SpaceReport.UnassignedSponsoredPeople.Configuration.ShowSalaryInformation.Changed',
      )
      .dispatch({ edit: { showSalaryInformation: value }, id: REPORT_ID })
  }
}
